"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAQ_TYPES = exports.MENU_ITEM_STYLING = exports.MENU_ITEM_STYLING_BUTTON = exports.MENU_ITEM_STYLING_LINK = exports.MENU_ITEM_TYPE = exports.DEFAULT_MENU_ITEM = exports.DEFAULT_MENU_TYPES = exports.MENU_ELEMENT_TYPE = exports.MENU_ELEMENT_TYPES = exports.MENU_ITEM_TYPES = exports.GROUP_STYLE = void 0;
exports.GROUP_STYLE = [
    { "": "" }, // unassigned, top of the list
    { "1": "default" }, // BP
    { "2": "highlighted" }, // PP
    { "3": "big" }, // LP
];
// Update MENU_ITEM_TYPES to include MAILING
exports.MENU_ITEM_TYPES = {
    INTERNAL: "internal",
    EXTERNAL: "external",
    MAILING: "mailto",
    DOWNLOAD: "download",
    APPLY_AS_SPEAKER: "apply-as-speaker",
    BECOME_PARTNER: "become-partner",
};
// Add MENU_ELEMENT_TYPES (new constant)
exports.MENU_ELEMENT_TYPES = {
    ITEM: "item",
    BUTTON: "button",
};
exports.MENU_ELEMENT_TYPE = ["item", "button"];
// Keep existing DEFAULT_MENU_TYPES as is
exports.DEFAULT_MENU_TYPES = {
    HOME: "home",
    AGENDA: "agenda",
    SPEAKER: "speaker",
    PARTNER: "partner",
    WHO_WHY: "who-&-why",
    EVENT_INFO: "event-info",
    CONTENT_HUB: "content-hub",
};
exports.DEFAULT_MENU_ITEM = [
    "home",
    "agenda",
    "speaker",
    "partner",
    "who-&-why",
    "event-info",
    "content-hub",
];
// Update MENU_ITEM_TYPE to include "mailto"
exports.MENU_ITEM_TYPE = [
    "home",
    "agenda",
    "speaker",
    "partner",
    "who-&-why",
    "event-info",
    "content-hub",
    "internal",
    "external",
    "mailto",
];
// Define constants for styling: 0 for link, 1 for button
exports.MENU_ITEM_STYLING_LINK = 0;
exports.MENU_ITEM_STYLING_BUTTON = 1;
// Add MENU_ITEM_STYLING object for backwards compatibility
exports.MENU_ITEM_STYLING = {
    LINK: exports.MENU_ITEM_STYLING_LINK,
    BUTTON: exports.MENU_ITEM_STYLING_BUTTON,
};
exports.FAQ_TYPES = {
    DEFAULT_IMAGE_RIGHT: "default-image-right",
    DEFAULT_IMAGE_LEFT: "default-image-left",
    EXTENDED_IMAGES_RIGHT: "extended-images-right",
    EXTENDED_IMAGES_LEFT: "extended-images-left",
    VENUE_LOCATION: "venue-location",
    HOTEL_RESERVATION: "hotel-reservation",
    PRE_EVENT_SESSION: "pre-event-session",
    NETWORKING_DINNER: "networking-dinner",
    MODERATOR_GUIDE: "moderator-guide",
    MATCHMAKING: "matchmaking",
    PLAIN: "plain",
    CONTACT: "contact",
};
